import { API_URL as baseApiUrl } from "@/config/env";

export const functionalAdminUrls = {
	//quotaSubmittionStatusData: baseApiUrl + "Quota/GetQuotaStatusGrpahData?",
    getSKUSwitchSearch: baseApiUrl + "ProductGroup/GetSKUSwitchSearch?",
    getGroupScenario: baseApiUrl + "Admin/GetGroupOrScenarioDetails?",
    getSearchCustomerTrustLevel: baseApiUrl + "Admin/SearchCustomerTrustLevel",
    getCustomersToRename : baseApiUrl + "Admin/GetCustomersToRename_pagination?",
    getCustomerGroupRefData: baseApiUrl + "Scenario/GetCustomerGroupReferenceData",
    updateCustomerData: baseApiUrl + "Admin/UpdateCustomerRename?",
    getCustomerCount: baseApiUrl + "Admin/GetCustomersToRename_Pagination_Count?",
    searchCustomerTrustLevel: baseApiUrl + "Admin/SearchCustomerTrustLevel?",
    updateCustomerTrustLevel: baseApiUrl + "Admin/UpdateCustomerTrustLevel",
    updateGroupOrScenarioActivation: baseApiUrl + "Admin/UpdateGroupOrScenarioActivation?",
    listUpdateGroupOrScenario: baseApiUrl + "Admin/ListUpdateGroupOrScenario",
};